import { Pipe, PipeTransform } from '@angular/core';
import { BankIdStatusEnum } from '@app/enums/bankid-status.enum';

@Pipe({
    name: 'bankIdIndicator',
})
export class BankIdIndicatorPipe implements PipeTransform {
    public transform(value: BankIdStatusEnum = BankIdStatusEnum.waiting): any {
        switch (value) {
            case BankIdStatusEnum.verified:
                return 'check_circle';
            case BankIdStatusEnum.waiting:
                return 'error_outline';
            case BankIdStatusEnum.checking:
                return 'check_circle';
            default:
                return 'error_outline';
        }
    }
}
